<!-- Backdrop with blur effect -->
<div class="slider-filter-backdrop"
     [ngClass]="{'slider-filter-backdrop-open': isOpen}"
     (click)="onBackdropClick()"
     [style.display]="isOpen ? 'block' : 'none'">
</div>

<!-- Slide Panel Content
     `.v3-wide` modifier narrows the panel to the 580px drawer called out
     in the mock (`gigsumo_job_center_v2(16).html` `.cp-slider`). V2 keeps
     its existing 50%/60%/100% responsive width. -->
<div class="slider-filter-content"
     [ngClass]="{'slider-open': isOpen, 'v3-wide': variant === 'v3', 'v3-single-scroll': variant === 'v3' && compactScroll}">

  <!-- V2 header (purple gradient + label). The V3 sliders paint their own
       sticky header inside the body, so we suppress this bar in V3. -->
  <div class="slider-filter-header" *ngIf="variant !== 'v3'">
    <div class="label">
      {{ panelType === 'job' ? 'Job Details' : 'Candidate Profile' }}
    </div>
    <div class="close-button" (click)="close()">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </div>
  </div>

  <!-- Body — variant routes V2 legacy summaries vs V3 4-tab sliders. -->
  <div class="slider-filter-body" [class.v3-body]="variant === 'v3'">

    <!-- ── V2 branch (unchanged) ──────────────────────────────────── -->
    <ng-container *ngIf="variant !== 'v3'">
      <ng-container *ngIf="panelType === 'job' && panelData">
        <app-job-profile-detail [jobDetails]="panelData" [isInSlider]="true" [candidateId]="candidateId"></app-job-profile-detail>
      </ng-container>
      <ng-container *ngIf="panelType === 'candidate' && panelData">
        <app-candidate-profile-summary [candidateDetails]="panelData" [isInSlider]="true" [jobId]="jobId"
          (candidateFilterFromComponent)="close()"></app-candidate-profile-summary>
      </ng-container>
    </ng-container>

    <!-- ── V3 branch (new 4-tab sliders) ──────────────────────────── -->
    <ng-container *ngIf="variant === 'v3'">
      <ng-container *ngIf="panelType === 'candidate' && panelData">
        <app-candidate-profile-slider
          [candidateSummary]="panelData"
          [jobId]="jobId"
          [jobData]="jobData"
          [initialTab]="initialTab"
          [pageFrom]="pageFrom"
          [hideAiInsights]="hideAiInsights"
          [hideChat]="hideChat"
          (closeRequested)="close()">
        </app-candidate-profile-slider>
      </ng-container>
      <ng-container *ngIf="panelType === 'job' && panelData">
        <app-job-profile-slider
          [jobSummary]="panelData"
          [candidateId]="candidateId"
          [candidateData]="candidateData"
          [initialTab]="initialTab"
          [pageFrom]="pageFrom"
          [hideAiInsights]="hideAiInsights"
          (closeRequested)="close()">
        </app-job-profile-slider>
      </ng-container>
    </ng-container>
  </div>
</div>
